
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Smartphone, Tablet, Server, Shield, Code, Link } from 'lucide-react';

const MobileAppsFeatures = () => {
  return (
    <section id="mobile-features" className="py-16 md:py-24">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Warum Ihr Unternehmen eine Mobile App benötigt
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            In einer zunehmend mobilen Welt können native Apps die Kundenbindung stärken und 
            interne Prozesse optimieren. Entdecken Sie die Vorteile der mobilen App-Entwicklung.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Smartphone className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Native iOS & Android Apps</h3>
              <p className="text-gray-600">
                Wir entwickeln hochperformante native Apps für iOS und Android mit bestem 
                Benutzererlebnis und voller Zugriff auf Gerätefunktionen.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Tablet className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Cross-Platform-Entwicklung</h3>
              <p className="text-gray-600">
                Mit modernen Frameworks entwickeln wir plattformübergreifende Apps, 
                die auf iOS und Android mit gleichbleibend hoher Qualität funktionieren.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Server className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Backend-Integration</h3>
              <p className="text-gray-600">
                Nahtlose Anbindung an bestehende Systeme und Datenbanken oder Entwicklung 
                einer maßgeschneiderten Backend-Lösung für Ihre App.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Shield className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Sicherheit & Datenschutz</h3>
              <p className="text-gray-600">
                Implementierung modernster Sicherheitsstandards und datenschutzkonformer 
                Lösungen nach DSGVO und Best Practices.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Code className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">UX/UI Design</h3>
              <p className="text-gray-600">
                Benutzerfreundliche Oberflächen und intuitive Navigation 
                durch professionelles UX/UI Design für maximale Nutzerzufriedenheit.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Link className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">App Store Publishing</h3>
              <p className="text-gray-600">
                Komplette Betreuung des Veröffentlichungsprozesses in den App Stores, 
                inkl. Optimierung für bessere Sichtbarkeit und Downloads.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default MobileAppsFeatures;
